<template>
  <div>
    <Header />
    <div class="success section">
      <div class="grid">
        <div class="grid-item img-box">
          <p class="text">배송신청이 완료 되었습니다.</p>
        </div>
        <div class="grid-item text-list">
          <ul>
            <li>배송신청 이후 실제 상품이 배송되기 까지 일정 기간이 추가로 소요 될 수 있습니다. </li>
            <li>상품의 배송이 시작되면 상세한 배송정보는 발급된 운송장번호를 기반으로 해당 배송사에 문의 하시기 바랍니다.</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Header from '@/components/Header';

export default {
  name: "DeliverRegister",
  components: {
    Header
  },
  data(){
    return {
      
    }
  },
  created(){
    
  }
};
</script>

<style scoped lang='scss'>
@import '@/assets/styles/mixin.scss';
@import '@/assets/styles/contents.scss';
.section{
  div.grid {
    padding-top: 0px;
    .img-box {
      padding: 106px 0px 86px;
      box-shadow: 0px 8px 14px -5px #e5e5e5 inset;
      &:before {
        background: url(../assets/images/bg_success.png) no-repeat center ;
        background-size: auto 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/DeliverRequestSuccess.vue